import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Family } from 'src/app/models/Family';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { ResponseReportOrderDetail } from 'src/app/models/ResponseReportOrderDetail';
import { ResponseReportOrderFinished } from 'src/app/models/ResponseReportOrderFinished';
import { SearchReport } from 'src/app/models/SearchReport';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { FamilyService } from 'src/app/services/family.service';
import { OrderService } from 'src/app/services/order.service';
import { PermissionService } from 'src/app/services/permission.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any; 

@Component({
  selector: 'app-orders-finished-report',
  templateUrl: './orders-finished-report.component.html',
  styleUrls: ['./orders-finished-report.component.scss']
})
export class OrdersFinishedReportComponent implements OnInit {

  @ViewChild('infoModal') infoModal: ModalDirective;
  @ViewChild('clear') clear;
  @ViewChild('clears') clears;
  @ViewChild(MatSort) sort: MatSort;

  titles: String[] = ['FECHA VENTA','FAMILIA', 'SUBFAMILIA','NOC','ARTÍCULO','TALLA','CANTIDAD','IMPORTE'];
    
  public families: Family[] = [];
  public subFamilies: Family[] = [];
  public familySelect: string;
  public subFamilySelect: string;
  public subFamiliesSelect: String[]=[];
  public period : Date;
  public form: FormGroup;
  public dateFromSelect: Date;
  public dateToSelect: Date;
  public search : boolean = false;
  public searchModal : boolean = false;
  public displayedColumns: string[] = ['orderNumber', 'dateOrder','dateShipment','ref'];
  public displayedDetailColumns: string[] = ['clothes','noc', 'size','amount','prices'];
  public usersList: String[] = [];
  public selectUser: String;
  public ordersRef: String[] = [];
  public listRef: String[] = [];
  public selectRef: String;
  keyword = 'name';
  public total: number=0;
  public totalDetail: number=0;

   
  public data: ResponseReportOrderFinished []; 
  public dataSourceDetailTotal: ResponseReportOrderDetail[] = []; 
  public dataSourceDetail : MatTableDataSource<ResponseReportOrderDetail>;

  public dataSource : MatTableDataSource<ResponseReportOrderFinished>;
  public dataSourceTotal: ResponseReportOrderFinished [];

  constructor( private reportService : ReportService,private clothesService: ClothesService, private spinner: NgxSpinnerService,private toastr: ToastrService, 
    private authService: AuthenticationService,private router: Router, private familyService: FamilyService, private permissionService: PermissionService,
    private orderService: OrderService) { }

  ngOnInit() {

    this.spinner.show();  
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
  }

  this.loadFamilies();
    this.loadUsers();
    this.loadRef();
    this.form = new FormGroup({
      'family': new FormControl('', Validators.required),
      'subFamily': new FormControl('', Validators.required),
      'dateFrom': new FormControl('', Validators.required),
      'dateTo': new FormControl('', Validators.required),
    });
     
  }

  /**Obtiene todos los usuarios para ser mostrados en el autocompletable */
  loadUsers(){
    this.permissionService.getAllUserWhitOrders().subscribe(
      data => {
        if (getToken(data)) {
          if(data.users != null && data.users.length>0){
            for (let i = 0; i < data.users.length; i++) {
                this.usersList.push(data.users[i]);
            }
          }else{
            this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE USUARIOS", "ERROR");
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE USUARIOS", "ERROR");
      }  
    )
  }

  /**Obtiene todos las referencias de envio para ser mostrados en el autocompletable */
  loadRef() {
    this.orderService.getShipmentOrdersFinished().subscribe(
      data => {
        if (getToken(data)) {
          if (data.orders != null && data.orders.length > 0) {
            for (let i = 0; i < data.orders.length; i++) {
              this.ordersRef.push(data.orders[i].shipmentReference);
            }
            for (let i = 0; i < this.ordersRef.length; i++) {
              if(!this.listRef.includes(this.ordersRef[i]))
                this.listRef.push(this.ordersRef[i]);
            }
          } else {
            this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE USUARIOS", "ERROR");
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS DE USUARIOS", "ERROR");
      }
    )
  }
  
  /**Obtiene las familias */
  loadFamilies() {
    this.spinner.show();
    this.familyService.getAll().subscribe(
      data => {
        if (getToken(data)) {
          for (let i = 0; i < data.families.length; i++) { 
             if(data.families[i].parent === null){
                this.families.push(data.families[i]);
             } else {
                this.subFamilies.push(data.families[i]);
             }
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }
    )
    this.spinner.hide();
  }

  /**Obtiene las subfamilias de la familia seleccionada */
  getSubfamilies() {
    this.spinner.show();
    this.subFamiliesSelect = [];
    this.subFamiliesSelect.push('');
    for (let i = 0; i < this.subFamilies.length; i++) {
      if (this.subFamilies[i].parent.name === this.familySelect) {
        this.subFamiliesSelect.push(this.subFamilies[i].name);
      }
    }
    this.spinner.hide();
  }

  loadReport() {
    let reportOrder = new ReportOrder();
    reportOrder.searchReport = new SearchReport();

    if(this.familySelect != null && this.familySelect.length>0){
      reportOrder.searchReport.family = this.familySelect.toString();
    }else{
      reportOrder.searchReport.family = null;
    }
    
    if(this.subFamilySelect != null && this.subFamilySelect.length>0){
      reportOrder.searchReport.subFamily = this.subFamilySelect.toString();
    }else{
      reportOrder.searchReport.subFamily = null;
    }

    /*if(this.selectUser != null && this.selectUser.length>0){
      reportOrder.searchReport.nid = this.selectUser.toString();
    }else{
      reportOrder.searchReport.nid = null;
    }*/

    if(this.selectRef != null && this.selectRef.length>0){
      reportOrder.searchReport.ref = this.selectRef.toString();
    }else{
      reportOrder.searchReport.ref = null;
    }

    if(this.dateFromSelect != null && this.dateToSelect != null){
      reportOrder.searchReport.toDate = this.dateToSelect;
      reportOrder.searchReport.fromDate = this.dateFromSelect;
    }else{
      reportOrder.searchReport.toDate = null;
      reportOrder.searchReport.fromDate = null;
    }

    if ((this.dateFromSelect != null && this.dateToSelect != null) && (this.dateFromSelect == this.dateToSelect)) {
      this.toastr.info("NO PUEDEN COINCIDIR LAS FECHAS");
    }
    else if (this.dateFromSelect > this.dateToSelect) {
      this.toastr.info("LA FECHA DE FIN NO PUEDE SER ANTERIOR A LA INCIO");
    }
    else if ((this.dateToSelect == null && this.dateFromSelect != null) || (this.dateToSelect != null && this.dateFromSelect == null)) {
      this.toastr.info("DEBE RELLENAR EL PERIODO DE MANERA COMPLETA");
    }else{
      reportOrder.responseReportOrder = [];
      reportOrder.responseReportSales = [];
      reportOrder.responseReportStore = [];
      reportOrder.responseReportOrderFinished = [];
      this.search = false;
   
      this.spinner.show();
      this.reportService.getReportOrderFinished(reportOrder).subscribe(
          data => {
            if (getToken(data)) {
              if(data.responseReportOrderFinished === null || data.responseReportOrderFinished.length===0){
                this.search = false;
                this.toastr.info("NO EXISTEN DATOS PARA MOSTRAR", "INFO");
              }else{
                this.search = true;
                this.dataSource = new MatTableDataSource(data.responseReportOrderFinished);
                this.data = data.responseReportOrderFinished;
                this.dataSourceTotal = data.responseReportOrderFinished;
                this.dataSource.sort = this.sort;
                this,this.total = data.responseReportOrderFinished.length;
              }
              
            }
            this.spinner.hide();
          }, error => {
            this.toastr.error(error);
            this.spinner.hide();
            this.logOut();
          }
        );
        this.spinner.hide();
    }

    
  }
  
  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  detailOrder(i: number){
    this.searchModal=true;
    this.dataSourceDetail = new MatTableDataSource(this.data[i].detail);
    this.dataSourceDetailTotal = [];
    this.dataSourceDetailTotal = this.data[i].detail;
    this.infoModal.show();
  }

    /**Método que se encarga de cerrar y liberar la memoria del modal*/
    closeModal(){
      this.searchModal=false;
      this.infoModal.hide();
      this.infoModal.ngOnDestroy();
    }

    /**Permite obtener el individuo*/
    selectEvent(item) {
      // do something with selected item
      this.selectUser = item;
    }

    /**Permite obtener la referencia*/
    selectEvents(item) {
      // do something with selected item
      this.selectRef = item;
    }
   
    onChangeSearch(val: string) {
      // fetch remote data from here
      // And reassign the 'data' which is binded to 'data' property.
      this.selectUser = val;
    }

    onChangeSearchs(val: string) {
      // fetch remote data from here
      // And reassign the 'data' which is binded to 'data' property.
      this.selectRef = val;
    }
    
    onFocused(e){
      // do something when input is focused
      this.clear.clear();
      this.selectUser = " ";
    }

    onFocuseds(e){
      // do something when input is focused
      this.clears.clear();
      this.selectRef = " ";
    }

    getTotalDetail() {
      this.totalDetail = 0;
      this.dataSourceDetailTotal.forEach(element => {
        this.totalDetail += element.prices;
      });
      return this.totalDetail;
    }

    getTotal() {
      return this.total;
    }

}
